import EmployeeSelect from '@/components/Form/Shared/EmployeeSelect'
import ProductGroupSelect from '@/components/Form/Shared/ProductGroupSelect'
import {
    CONTRACT_DIRECTION_OPTIONS,
    CONTRACT_ROLE_OPTIONS,
    CONTRACT_STATUS,
} from '@/modules/Contract/constants'
import dayjs from 'dayjs'
import { Control, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { FormItem } from 'vnetwork-ui'

interface FiltersProps {
    control: Control<any>
}

const formatDateRangeTitle = (value: unknown) => {
    if (!Array.isArray(value) || !value[0]) return ''
    const from = dayjs(value[0])
    const to = value[1] ? dayjs(value[1]) : null
    const fromText = from.isValid() ? from.format('DD/MM/YYYY') : ''
    const toText = to?.isValid() ? to.format('DD/MM/YYYY') : ''
    return toText ? `${fromText} - ${toText}` : fromText
}

const Filters: React.FC<FiltersProps> = ({ control }) => {
    const { t } = useTranslation()
    const createdAt = useWatch({ control, name: 'created_at' })
    const createdAtTitle = formatDateRangeTitle(createdAt)
    return (
        <>
            <FormItem
                control={control}
                name="contract_id"
                type="number"
                label={t('contract_id')}
                placeholder={t('contract_id')}
            />
            <FormItem
                control={control}
                name="contract_number_id"
                type="textfield"
                label={t('contract_number_id')}
                placeholder={t('contract_number_id')}
            />
            <FormItem
                control={control}
                name="contract_key"
                type="textfield"
                label={t('contract_key')}
                placeholder={t('contract_key')}
            />
            <FormItem
                className="hidden"
                control={control}
                name="contract_status"
                type="select"
                multiple
                options={CONTRACT_STATUS(t)}
                label={t('contract_status')}
                placeholder={t('contract_status')}
            />
            <FormItem
                control={control}
                name="contract_role"
                type="select"
                multiple
                options={CONTRACT_ROLE_OPTIONS(t)}
                label={t('contract_role')}
                placeholder={t('contract_role')}
            />
            <FormItem
                control={control}
                name="contract_direction"
                type="select"
                multiple
                options={CONTRACT_DIRECTION_OPTIONS(t)}
                label={t('contract_direction')}
                placeholder={t('contract_direction')}
            />
            <div className="col-span-2 bg-white">
                <EmployeeSelect
                    multiple
                    showLabel={false}
                    name="employee_id"
                    control={control}
                />
            </div>
            <ProductGroupSelect
                control={control}
                showLabel={false}
                name="product_group_name"
                multiple
            />
            <div className="min-w-0" title={createdAtTitle}>
                <FormItem
                    className="min-w-0 [&_[data-ui-component='TextField']]:w-full [&_.text-field-container]:w-full [&_.text-field-container]:min-w-0 [&_.text-field]:min-w-0 [&_.text-field]:pr-10 [&_.text-field]:overflow-hidden [&_.text-field]:text-ellipsis [&_.text-field]:whitespace-nowrap"
                    control={control}
                    name="created_at"
                    type="daterangepicker"
                    placeholder={t('created_at')}
                />
            </div>
        </>
    )
}

export default Filters
